import { ResponsiveContainer } from '@capsicum/common-web';
import { type PropsWithChildren } from 'react';
import styled from 'styled-components';

export const PageWrapper = ({ children }: PropsWithChildren) => {
	return <S.Wrapper $variant="subpage">{children}</S.Wrapper>;
};

namespace S {
	export const Wrapper = styled(ResponsiveContainer)`
		flex: 1;
		align-items: center;
		flex-direction: column;
	`;
}
